import React, {useEffect, useState} from 'react';
import {Trigger} from "types/Trigger";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    trigger: Trigger | null
    show: boolean
    onDelete?: (trigger: Trigger) => any
    onDeleteFail?: (trigger: Trigger, error: unknown) => any
    onCancel?: () => any
}

function DeleteTrigger(props: Props) {
    const {trigger, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(trigger?.name || 'this trigger');
    const {mutateAsync: deleteTrigger} = useMutation(ngage.triggers.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if (trigger) setName(trigger.name)
    }, [trigger]);

    async function handleDeleteTrigger() {
        if (trigger) {
            try {
                await deleteTrigger(trigger.id)
                await invalidate('triggers.all')

                if (onDelete) {
                    notify("success", "Trigger Deleted", `${trigger.name} has been permanently removed`)
                    onDelete(trigger)
                }
            } catch (error) {
                if (onDeleteFail) {
                    notify("error", "Trigger Not Deleted", `${trigger.name} could not be removed`)
                    onDeleteFail(trigger, error)
                }
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Trigger"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteTrigger}
            onCancel={handleCancel}
        />
    );
}

export default DeleteTrigger;